export default "__VITE_ASSET__CZGpD5Sh__"